<script setup></script>

<template>
    <div
        class="modal fade"
        id="shareByQr"
        data-bs-backdrop="false"
        tabindex="-1"
        aria-labelledby="shareByQr"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-l modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="justify-content: center">
                    <div class="" style="justify-content: center">
                        <h5 class="modal-title" id="shareByQr">Share via QR</h5>
                    </div>
                    <button
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        style="position: absolute; right: 32px"
                    >
                        <svg
                            class=""
                            width="16px"
                            height="16px"
                            viewBox="-0.5 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                                <path
                                    d="M3 21.32L21 3.32001"
                                    stroke="#808080"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                                <path
                                    d="M3 3.32001L21 21.32"
                                    stroke="#808080"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                            </g>
                        </svg>
                    </button>
                </div>

                <div class="modal-body m-auto">
                    <div class="row">
                        <div class="col-lg-12 align-content-center">
                            <qrcode-vue
                                :value="value + user.username"
                                size="300"
                                level="H"
                                style="width: 100%; height: auto !important"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
    props: ["value", "user"],
    components: {
        QrcodeVue,
    },
};
</script>
